module.exports = __webpack_public_path__ + "static/media/instagramIcon.0ad55ad1.svg";